module.exports = __webpack_public_path__ + "static/media/porte4.75c80eb7.jpg";